import React, { useContext } from "react";
import { IntlContext } from "context";
import { Loader as LoaderUI } from "ui/Loader";

const Loader: React.FC = () => {
    const intl = useContext(IntlContext);
    return (
        <LoaderUI
            fullScreen
            message={intl.formatMessage("generic.loading")}
        />
    );
};

export default Loader;
